import React, { useState } from 'react';

export function LegalTermsModal({ onAgree, onClose }) {
  const [agreed, setAgreed] = useState(false);

  return (
    <div
      className="fixed inset-0 z-[80] flex items-end justify-center bg-black/70 p-2 sm:items-center sm:p-3"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="flex max-h-[calc(100dvh-0.5rem)] w-full max-w-lg flex-col overflow-hidden rounded-t-2xl border border-gray-300 bg-white shadow-xl sm:max-h-[90vh] sm:rounded-lg"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="legal-terms-title"
      >
        <div className="flex shrink-0 items-start justify-between gap-3 border-b border-gray-200 px-4 py-3 sm:px-5">
          <h4 id="legal-terms-title" className="text-sm font-semibold text-gray-900">
            Legal terms
          </h4>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex min-h-10 shrink-0 items-center px-1 text-xs font-semibold text-gray-500 hover:text-gray-800 sm:min-h-0"
          >
            Close
          </button>
        </div>

        <div className="px-4 py-3 text-xs leading-relaxed text-gray-700 sm:px-5">
          <p>
            By submitting this form, I confirm the information is true and complete, and I agree
            this record may be stored and shared with authorized company and site safety staff.
            This does not replace my duty to follow site rules and safe work practices. Checking
            the box below is my electronic agreement to these terms.
          </p>
        </div>

        <div className="shrink-0 border-t border-gray-200 px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] sm:px-5">
          <label className="flex min-h-11 cursor-pointer items-start gap-2.5 sm:min-h-0 sm:items-center">
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              className="mt-0.5 h-4 w-4 shrink-0 cursor-pointer accent-[#eda448] sm:mt-0"
            />
            <span className="text-[11px] font-medium text-gray-800">
              I have read and agree to the legal terms.
            </span>
          </label>
          <div className="mt-3 flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="inline-flex h-10 min-w-[5.5rem] items-center justify-center rounded border border-gray-300 px-4 text-sm font-semibold text-gray-700 hover:bg-gray-50 sm:h-8"
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={!agreed}
              onClick={onAgree}
              className="inline-flex h-10 min-w-[5.5rem] items-center justify-center rounded bg-[#eda448] px-4 text-sm font-semibold text-gray-900 hover:bg-[#d8932e] disabled:cursor-not-allowed disabled:opacity-50 sm:h-8"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
